export default __webpack_public_path__ + "static/media/mod01.aee29d01.svg";